var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-ribbon-root"},[_c('div',{staticClass:"icon",style:(_vm.inlineStyle)}),_vm._v(" "),_c('div',{staticClass:"text"},[_c('div',[_vm._v(_vm._s(_vm.contractName))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.locationName))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69b8a026","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderRibbon.vue
// module id = null
// module chunks = 